import type { MailboxInfo } from 'owa-client-types';
import { getBizChatWindowKey, openCopilotChatDrawer } from 'owa-copilot-chat-drawer-store';
import type { TasksHubViewSource } from './logTasksHubViewed';
import { showTasksHub } from './showTasksHub';

export function openCopilotTasksHub(
    targetWindow: Window,
    mailboxInfo: MailboxInfo,
    source: TasksHubViewSource
): void {
    showTasksHub(getBizChatWindowKey(targetWindow), mailboxInfo, source);
    openCopilotChatDrawer(targetWindow, mailboxInfo, { EntryPoint: source });
}
